// The form's shape is not the request's shape: the company filter holds chips (so it can show a
// symbol and name) while /feed/view takes bare numeric ids. Kept as pure functions so the mapping is
// testable without rendering the page.

// The SLICE OF THE WORLD a read covers — the window and the companies — with no feed in it.
//
// Split out because four of the five call sites name their own feed and their own slim, and were
// overriding this helper's by spread order:
//
//   run({ ...buildViewParams(formState), feedId, slim, ... })  // after the spread, which carries
//                                                              // the form's own slim
//
// That works, and it needed a comment at every site to say why. Naming the scope separately lets
// those sites pass explicit arguments instead of relying on key order, which is not a property
// anyone should have to check when adding a field.
//
// `companies` travels alongside `companyIds`. The wire takes only the ids — buildViewBody
// destructures the fields it sends rather than spreading, so a chip cannot reach the server — but
// the recent-runs list records the chips, and toRecentRun reads `params.companies`. Emitting both
// here is what removes the page's habit of patching the chips back on afterwards:
//
//   pendingRunRef.current = { ...params, companies: state.companies };  // gone
export const buildScopeParams = (formState) => ({
  knowableFrom: formState.fromDate,
  knowableTo: formState.toDate,
  companyIds: (formState.companies || []).map((c) => c.company_id),
  companies: formState.companies || [],
});

// A complete read: the scope, plus which feed and at what fidelity.
export const buildViewParams = (formState) => ({
  ...buildScopeParams(formState),
  feedId: formState.feedId,
  slim: !!formState.slim,
});
